import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CheckoutRequest, CheckoutResponse, OrderStatus } from '~models/checkout.model';
import { CreateOrderRequest, Order } from '~models/order.model';

@Injectable()
export class CheckoutV2Service {
  public responseComplete: any;

  constructor(private ngHttp: HttpClient) {}

  checkiOSVersion() {
    var agent = window.navigator.userAgent.toLowerCase(),
      start = agent.indexOf('/'),
      end = agent.indexOf(' ', start);

    if (/iphone|ipod|ipad/.test(agent) && start > -1) {
      let iosVerion = agent.substr(start, end - start).replace('/', '');
      if (iosVerion >= '1.1.5') {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  checkandroidVersion() {
    var agent = window.navigator.userAgent.toLowerCase(),
      start = agent.indexOf('/'),
      end = agent.indexOf(' ', start);

    if (/android/.test(agent) && start > -1) {
      let androidVerion = agent.substr(start, end - start).replace('/', '');
      if (androidVerion >= '1.1.2') {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  async createCheckout(checkoutRequest: CheckoutRequest) {
    const urlWithParams = `${environment.v2ApiUri}/checkout`;
    return this.ngHttp.post<CheckoutResponse>(urlWithParams, checkoutRequest).toPromise();
  }

  async createOrder(createOrderRequest: CreateOrderRequest): Promise<Order> {
    const response = await this.ngHttp
      .post<Order>(`${environment.v2ApiUri}/orders`, createOrderRequest)
      .toPromise();

    return response;
  }

  async getOrderById(id: string): Promise<Order> {
    const response = await this.ngHttp
      .get<Order>(`${environment.v2ApiUri}/orders/${id}`)
      .toPromise();
    return response;
  }
}
